import React, { Component, Fragment } from "react";
import { Container, Row } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddAnnounceType from '../../components/Admin/addHebergement'
import AddAnnounceCar from '../../components/Admin/addCar'
import httpClient from "../../httpClient";
import '../../style/css/pro/Admin.css'
import {
  faUserCircle,
  faPlus,
  faBullhorn,
  faHistory,
  faUsers,
  faPlane,
  faMapSigns,
  faBed,
  faBus,
  faCar,
  faPaperPlane,
  faChevronCDown,
  faChevronDown,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";
 import {
  NavLink, 
  } from "reactstrap";
  import { withRouter } from "react-router-dom";
  import { connect } from 'react-redux';
import { addAnn } from "../../slices/modalSlice";
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import Calender from '../../components/common/calender';
import Switch from '@mui/material/Switch';
import DashCatego from "../../components/Admin/dashCatego";
import DashMenuItem from "../../components/Admin/dashMenuItem";
import DashAnnounce from "../../components/Admin/dashAnnounce";
import DiscussRow from "../../components/Admin/discussRow";
import MsgHeader from "../../components/Admin/msgHeader";
import Footer from "../../components/common/global_layout/footer";
import axios from "axios";
import {io} from "socket.io-client";

import { get, post } from "request";
import Message from "../../components/Admin/message";
import Dropzone from 'react-dropzone'

class Discussion extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      message : "",
      messages : [],
      arrivalMessage : null,
      conversation : {},
      friendUser : {},
      arrayCopy : [],
      stopInfinteLoop :false,
      galleryId : "",
      urlMessage : "",
      hostName : process.env.REACT_APP_SERVER_URL
    }
    this.scrollRef = React.createRef();
    this.socket = React.createRef(io("ws://localhost:8900"));
}


user = this.props.currentUser

conversationData = this.props.location.state


conversation ;
  



  getConversation = async () => {
    try {
      const res = await axios.get(`${this.state.hostName}/api/conversations/conv/`+window.location.href.substring(window.location.href.indexOf('rie') + 4))
      console.log(res);

       return res.data
    } catch (error) {
      console.log(error);
    }
  }

getMessages = async () => {
  try {
    
    const HOST_NAME = this.state.hostName ;
   
    let cnv ;
    if (typeof this.conversationData !== "undefined"  ) {
      cnv = this.conversationData.convId 
    }
    else cnv = window.location.href.substring(window.location.href.indexOf('rie') + 4)
  
    const res = await axios.get(`/api/messages/`+this.conversation._id)

    this.setState({messages : res.data})
    this.setState({
      stopInfinteLoop : true
    })
    console.log("getmsssg");
     

    
  } catch (error) {
    console.log(error);
  }
}


getUser =  (conv) =>{
  let friend = conv.members.find((m)=> m !== this.user._id)
  return httpClient.getUser(friend).then(
      res => {
        return res    
      }
  )
}


sendMessage = async (e,text) =>{
  e.preventDefault()
  if (text !== ""){
    const newMessage = await {
      sender : this.user._id,
      conversationId : this.state.conversation._id,
      message : text.includes("/api")  ? "http://localhost:5000"+text : text 
    }
  
    const recieverId =  this.state.conversation.members.find((m)=> m !== this.user._id)
   
    await this.socket.current.emit("sendMessage",{
      senderId : this.user._id,
      recieverId,
      text : text.includes("/api")  ? "http://localhost:5000"+text : text 
    })
    console.log(this.socket.current);
  
  
    try {
      const HOST_NAME = this.state.hostName ;
      const res = await axios.post(`/api/messages`, newMessage)
      this.setState({messages : [...this.state.messages,res.data]})
      this.setState({message : "", urlMessage : ""})
      this.excuteScroll()
    } catch (error) {
      console.log(error);
    }
  }
 
}

excuteScroll = () =>{
  
  this.scrollRef.current?.scrollIntoView({  block: 'nearest' })
}

async componentDidMount(prevProps,prevState) {
  this._isMounted = true;
 

console.log("mount");

  this.socket.current =  io("ws://localhost:8900")

 
   this.socket.current.emit("addUser", this.user._id)
   this.socket.current.on("getUsers", users =>{
  })


  let conversation = await this.getConversation()
  

 await  typeof this.conversationData !== "undefined" ? this.conversation = this.conversationData.conversation : this.conversation = conversation
 

  
   let friendUser = await this.getUser(this.conversation)

this.setState({
  friendUser : friendUser ,
  conversation : conversation
})

  this.getMessages()
  



  
  
}

 async componentDidUpdate (prevProps,prevState){

  this.socket.current.on("getMessage", data =>{

    this.setState({arrivalMessage : {
      sender : data.senderId,
      text : data.text,
      //createdAt : Date.now()
    }})
 
  })
 
   this.state.arrivalMessage 
   && this.state.conversation.members.includes(this.state.arrivalMessage.sender) 
   && this.setState(prevState =>({messages :[...prevState.messages, this.state.arrivalMessage]})) 

   console.log("New message");

  console.log("update");



 this.getMessages()
   


}


onDrop =async (files) =>{
  const HOST_NAME = this.state.hostName ;
const galleryId =   await httpClient.uploadFileMessage(files[0])
this.setState({
  urlMessage : `/api/announces/`+galleryId+"/avatar/0/"+galleryId+".jpeg"
})
}
  
  





  render() {

    return (
    <>

    <div className="container pt-4 mb-5 pb-5">
       <div className="col-12">
         
         <div className="mt-4">
            <div className="conv__header d-flex justify-content-between align-items-center px-1">
                 <h2 className="bienvenu__txt mb-0">Conversation : {this.state.friendUser.name}</h2>
                 <div className="d-flex align-items-center ">
                    <img src="/imgs/dash/times.svg" className="msg__actions ml-3" alt="" />
                    <img src="/imgs/dash/archive_do.svg" className="msg__actions ml-3 mt-1" alt="" />
                 </div>
                 
             </div>
             <hr />
             <div className="discussion">
                 <div  className="messages px-2 pt-3 pb-1 mb-3">
               
        
                   {this.state.messages.map((msg =>(
                   <div ref={this.scrollRef}>
                          <Message   message={msg.message} user={this.state.friendUser.name} own ={msg.sender === this.user._id} />
                   </div>
                    
                      
                  ) ))}
                  
                  
                 
                 </div>

                 <div>
                    <form className="d-flex justify-content-between" onSubmit={(e) => this.sendMessage(e,this.state.message || this.state.urlMessage)}>
                     <input type="text" name="message" className="msgInput mr-2" id="message" placeholder="Votre message ici.." onChange={(e) => this.setState({message :  e.target.value})} value={this.state.message || this.state.urlMessage}/>
                     <Dropzone  onDrop={this.onDrop}>
                       {({getRootProps, getInputProps}) => (
                         <section>
                           <div {...getRootProps()}>
                             <input {...getInputProps()} />
                             <button type="button" className="sendBtn mr-2"  ><img className="sendIc" width="12px" src="/imgs/messagerie/file.svg"/></button>
                           </div>
                         </section>
                       )}
                     </Dropzone>
                     <button className="sendBtn" type="submit"><img className="sendIco" width="19px" src="/imgs/messagerie/send.svg"/></button>
                    </form>
                 </div>
             </div>
         </div>
       </div> 
      
    </div>



  <Footer />



    </>

    );
  }
}




function mapStateToProps(state) {
  return {
    test :state.messages
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(Discussion));